import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-doc-preview-modal',
  templateUrl: './doc-preview-modal.component.html',
  styleUrls: ['./doc-preview-modal.component.css']
})
export class DocPreviewModalComponent {
  /** File URL to preview */
  @Input() url!: string;

  /** File name or title */
  @Input() title: string = 'Preview';

  /** Optional action buttons */
  @Input() showDownload: boolean = false;
  @Input() showOpenNewTab: boolean = false;

  /** Close modal event */
  @Output() close = new EventEmitter<void>();

  /** Detected file type */
  fileType: 'image' | 'pdf' | 'office' | 'text' | 'unknown' = 'unknown';

  /** Safe URL for iframe */
  safeUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges() {
    this.detectFileType();
    this.setSafeUrl();
  }

  private detectFileType() {
    if (!this.url) {
      this.fileType = 'unknown';
      return;
    }

    const ext = this.url.split('.').pop()?.toLowerCase() || '';

    if (['jpg','jpeg','png','gif','bmp','svg','webp'].includes(ext)) this.fileType = 'image';
    else if (ext === 'pdf') this.fileType = 'pdf';
    else if (['doc','docx','xls','xlsx','ppt','pptx'].includes(ext)) this.fileType = 'office';
    else if (['txt','csv','log'].includes(ext)) this.fileType = 'text';
    else this.fileType = 'unknown';
  }

  private setSafeUrl() {
    if (!this.url) return;

    if (this.fileType === 'office') {
      const viewerUrl = `https://docs.google.com/gview?url=${this.url}&embedded=true`;
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(viewerUrl);
    } else {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
  }

  downloadFile() {
    if (!this.url) return;
    const link = document.createElement('a');
    link.href = this.url;
    link.download = this.url.split('/').pop() || 'file';
    link.click();
  }

  openInNewTab() {
    if (!this.url) return;
    window.open(this.url, '_blank');
  }

  closeModal() {
    this.close.emit();
  }
}
